export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxwZWFjZWZ1bCUyMHdhcm0lMjBpbnRlcmlvciUyMGxpZ2h0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MjA5NzY0NXww&ixlib=rb-4.1.0&q=85",
  windows: "https://images.unsplash.com/photo-1778442450977-c5c74923d817?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHw0fHxwZWFjZWZ1bCUyMHdhcm0lMjBpbnRlcmlvciUyMGxpZ2h0JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc5MjA5NzY0NXww&ixlib=rb-4.1.0&q=85",
  conversation: "https://images.unsplash.com/photo-1758525226597-6263703aca5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxhZnJpY2FuJTIwZnJpZW5kcyUyMGNvbnZlcnNhdGlvbiUyMHdhcm18ZW58MHx8fHwxNzkyMDk3NjQ1fDA&ixlib=rb-4.1.0&q=85",
  sanctuary: "/images/dawn-sanctuary.jpg",
  circle: "/images/open-conversation.jpg",
  counselling: "/images/counselling-room.jpg",
  walk: "/images/calm-walk-wellness.jpg",
  therapist: "/images/therapist-portrait.jpg",
  tea: "/images/morning-tea.jpg",
  botanical: "/images/botanical-light.jpg",
  school: "/images/school-circle.jpg",
  wellnessRoom: "/images/wellness-room.jpg",
  garden: "/images/garden-moment.jpg",
  journal: "/images/journal-stilllife.jpg",
  doorway: "/images/doorway-room.jpg",
};

export const GALLERY = [
  { key: "circle", caption: "Warm light, open conversation" },
  { key: "counselling", caption: "Calm counselling in a Johannesburg therapy room" },
  { key: "therapist", caption: "A welcoming presence, held in soft light" },
  { key: "walk", caption: "A calm walk through wellness" },
  { key: "school", caption: "A school wellbeing circle" },
  { key: "garden", caption: "A mother and daughter share a garden moment" },
  { key: "tea", caption: "Morning calm: tea, journalling and reflection" },
  { key: "journal", caption: "A quiet morning journal still life" },
  { key: "botanical", caption: "An opening toward warm light" },
  { key: "sanctuary", caption: "Dawn in the reading sanctuary" },
  { key: "wellnessRoom", caption: "A serene wellness room, table mountain light" },
  { key: "doorway", caption: "A quiet, private room beyond the door" },
];

export const NAV_SECTIONS = [
  { id: "vision", label: "Vision" },
  { id: "experience", label: "Experience" },
  { id: "concept", label: "Concept" },
  { id: "scope", label: "Scope" },
  { id: "delivery", label: "Delivery" },
  { id: "investment", label: "Investment" },
  { id: "discuss", label: "Discuss the Project" },
];

export const CURVE_STAGES = [
  { step: "01", name: "Arrive", quote: "I feel calmer." },
  { step: "02", name: "Recognise", quote: "This is for me." },
  { step: "03", name: "Explore", quote: "I understand my options." },
  { step: "04", name: "Trust", quote: "These people feel credible." },
  { step: "05", name: "Choose", quote: "I know where to go." },
  { step: "06", name: "Act", quote: "I feel ready to enquire." },
];

export const AUDIENCES = [
  {
    id: "support",
    label: "I am looking for support",
    img: "counselling",
    pathway: ["Arrive gently, without a wall of information", "Choose the kind of support that fits", "Understand the service and who practises it", "Send a private enquiry, in your own words"],
    next: "Explore therapy and counselling",
  },
  {
    id: "parent",
    label: "I am a parent or caregiver",
    img: "garden",
    pathway: ["Find the questions parents carry, answered plainly", "Understand what support suits a child or teen", "Meet the people who would work with your family", "Enquire privately, with no obligation"],
    next: "See family and youth support",
  },
  {
    id: "school",
    label: "I represent a school or organisation",
    img: "school",
    pathway: ["Define the need: learners, parents or staff", "Review relevant programmes and approach", "Check credentials and delivery model", "Request a consultation or proposal"],
    next: "View organisational services",
  },
  {
    id: "learn",
    label: "I want to learn or train",
    img: "walk",
    pathway: ["Browse programmes and upcoming cohorts", "Check requirements, dates and format", "Understand what the training leads to", "Send a training enquiry"],
    next: "Discover training and courses",
  },
  {
    id: "resources",
    label: "I am looking for resources",
    img: "journal",
    pathway: ["Explore at your own pace, no sign-up", "Filter by topic: anxiety, families, schools", "Read, listen or save for later", "Move to support only when ready"],
    next: "Browse the resource library",
  },
];

export const CONCEPT_SCREENS = [
  { id: "home", num: "01", title: "Homepage", badge: "First impression", img: "sanctuary", desc: "Calm arrival, immediate orientation, audience doorways instead of a menu maze." },
  { id: "discovery", num: "02", title: "Therapy discovery", badge: "Care navigation", img: "counselling", desc: "Support areas presented in plain language, with gentle filtering." },
  { id: "practitioner", num: "03", title: "Practitioner profile", badge: "Human first", img: "therapist", desc: "Meet the person before the appointment: approach, areas, availability." },
  { id: "family", num: "04", title: "Family and youth", badge: "Specialist track", img: "garden", desc: "Answers to the questions parents carry before they are ready to enquire." },
  { id: "schools", num: "05", title: "Schools and organisations", badge: "Institutional", img: "school", desc: "From defined need to programme options to consultation request." },
  { id: "training", num: "06", title: "Training discovery", badge: "Professional", img: "walk", desc: "Programmes, requirements and dates presented decision-ready." },
  { id: "resources", num: "07", title: "Resource library", badge: "Editorial", img: "journal", desc: "Curated, not crowded. Guidance people can explore at their own pace." },
  { id: "events", num: "08", title: "Events and workshops", badge: "Community", img: "circle", desc: "Gatherings and workshops that build trust and repeat visits." },
  { id: "form-therapy", num: "09", title: "Therapy enquiry", badge: "Micro-form", img: "botanical", desc: "Private and gently worded. Routing information only; no clinical history." },
  { id: "form-school", num: "10", title: "School consultation enquiry", badge: "Institutional form", img: "school", desc: "Commercially useful structure for heads, boards and HR leads." },
  { id: "form-training", num: "11", title: "Training enquiry", badge: "Decision-ready", img: "walk", desc: "Programme, dates and requirements in one short exchange." },
];

export const JOURNEYS = [
  {
    id: "therapy",
    label: "Therapy journey",
    tone: "Private and gently worded",
    steps: ["Visitor need", "Support area", "Service information", "Practitioner information", "Private enquiry"],
    note: "Each step lowers the emotional cost of continuing. The form gathers routing information only; a secure clinical intake can follow later, if the practice requires it.",
    imageKey: "counselling",
    imageAlt: "A calm one-to-one counselling conversation in a warm therapy room",
  },
  {
    id: "school",
    label: "School journey",
    tone: "Commercially useful",
    steps: ["School challenge", "Programme options", "Organisational credentials", "Consultation request"],
    note: "An institutional buyer needs to justify the decision internally. The journey surfaces programme fit, delivery approach and proof before asking for a meeting.",
    imageKey: "school",
    imageAlt: "A school wellbeing circle with a facilitator and learners in warm light",
  },
  {
    id: "training",
    label: "Training journey",
    tone: "Decision-ready",
    steps: ["Training interest", "Programme information", "Requirements and dates", "Training enquiry"],
    note: "A practitioner comparing programmes needs facts fast. Requirements, format and dates arrive before the enquiry, so the conversation starts informed.",
    imageKey: "walk",
    imageAlt: "A practitioner walking calmly through a warm, plant-filled wellness space",
  },
];

export const ARCHITECTURE = [
  { branch: "Therapy and counselling", items: ["Service pages", "Practitioner profiles", "Therapy enquiry"] },
  { branch: "Schools and organisations", items: ["Programme pages", "Organisational proof", "Consultation enquiry"] },
  { branch: "Training and learning", items: ["Programme pages", "Events and workshops", "Training enquiry"] },
  { branch: "Resources", items: ["Articles", "Mental-health guidance", "Events"] },
];

export const CORE_PLATFORM = ["Home", "About", "Contact", "FAQs", "Privacy", "Crisis guidance", "Content management"];

export const SCOPE_CHAPTERS = [
  {
    num: "01",
    title: "Brand Foundation",
    intro: "The identity the organisation will grow into.",
    items: ["Business naming", "Brand positioning", "Messaging architecture", "Logo and visual identity", "Colour and typography system", "Brand guidelines"],
  },
  {
    num: "02",
    title: "Core Website",
    intro: "The dependable centre of the platform.",
    items: ["Home, about and contact", "FAQs and privacy", "Crisis support guidance", "Required utility pages", "Responsive build and accessibility"],
  },
  {
    num: "03",
    title: "Care Experience",
    intro: "The route from uncertainty to enquiry.",
    items: ["Therapy overview", "Agreed service pages", "Practitioner profiles", "Private therapy enquiry", "Family and youth pathways"],
  },
  {
    num: "04",
    title: "Organisations and Learning",
    intro: "The broader offer, clearly organised.",
    items: ["School and organisational services", "Training and course discovery", "Events and workshops", "Resource library", "Dedicated enquiry routes"],
  },
];

export const ROADMAP = [
  { weeks: "Week 1", phase: "Discovery and alignment", deliverables: "Stakeholder conversations, audience mapping, content audit and success measures agreed together.", gate: "Direction confirmed" },
  { weeks: "Weeks 1–3", phase: "Naming, positioning and visual identity", deliverables: "Name shortlist, positioning statement, logo and visual identity system, brand guidelines.", gate: "Identity approved" },
  { weeks: "Weeks 3–5", phase: "UX architecture, content planning and interface design", deliverables: "Sitemap, audience journeys, page-by-page content plan and high-fidelity interface design.", gate: "Experience signed off" },
  { weeks: "Weeks 5–8", phase: "Responsive website build", deliverables: "Full responsive build, enquiry pipelines, content management and accessibility checks.", gate: "Build-complete review" },
  { weeks: "Weeks 6–9", phase: "Copy, imagery and content population", deliverables: "Website copywriting, image direction and sourcing, practitioner and programme content loaded.", gate: "Content approved" },
  { weeks: "Weeks 9–10", phase: "Testing, refinement, training and launch", deliverables: "Cross-device testing, refinement, team training, launch and handover.", gate: "Launch" },
];

export const INVESTMENT_OPTIONS = [
  {
    id: "upfront",
    name: "Upfront",
    amount: "R80 275",
    badge: "5% commitment discount",
    sequence: [{ when: "At appointment", amount: "100% · R80 275", achieves: "The full engagement is secured and the delivery schedule is reserved in one step." }],
  },
  {
    id: "milestone",
    name: "Milestone Plan",
    amount: "R84 500",
    badge: "Recommended",
    recommended: true,
    sequence: [
      { when: "At appointment", amount: "40% · R33 800", achieves: "Discovery, naming and identity work begins." },
      { when: "After brand and UX approval", amount: "30% · R25 350", achieves: "The identity and experience direction are signed off with confidence." },
      { when: "At build-complete review", amount: "20% · R16 900", achieves: "The full responsive website is reviewed together before content sign-off." },
      { when: "Before launch", amount: "10% · R8 450", achieves: "Final refinement, training and launch." },
    ],
  },
  {
    id: "extended",
    name: "Extended Plan",
    amount: "R90 000",
    badge: "Cash-flow friendly",
    sequence: [
      { when: "Deposit", amount: "R30 000", achieves: "The engagement begins with the same full scope and schedule." },
      { when: "Months 1–6", amount: "6 × R10 000", achieves: "The balance is spread across six monthly payments while the platform operates." },
      { when: "In the agreement", amount: "To be defined", achieves: "Final operating and ownership arrangements are set out clearly before signature." },
    ],
  },
];

export const PARTNERSHIP_INCLUDES = [
  "Hosting coordination and backups",
  "Security, uptime and form checks",
  "Up to four hours of routine website changes",
  "One article or event upload per month",
  "Analytics and performance review",
  "Ongoing content guidance",
];

export const FUTURE_MODULES = [
  "Live appointment booking",
  "Online payment",
  "Practitioner matching",
  "Secure client accounts",
  "Training and learning portal",
  "CRM and email automation",
  "Multilingual expansion",
];

export const TRUST_CLAUSES = [
  { title: "Minimum necessary data", text: "The first release collects only what is needed to route an enquiry: basic contact details, audience type and area of interest. Not a clinical history." },
  { title: "Clear consent", text: "Every form states its purpose, links the privacy notice and asks permission before any contact is made." },
  { title: "Secure, POPIA-aware handling", text: "Form data is handled securely with privacy-notice visibility throughout, designed with South African data-protection principles in mind." },
  { title: "Crisis and emergency guidance", text: "Prominent, compassionate guidance for visitors in crisis, with transparent service limitations. The website is not an emergency service." },
  { title: "Honest boundaries", text: "The initial platform is not a clinical record system, telehealth platform or emergency service, and it will never pretend to be." },
  { title: "A secure future path", text: "When the practice is ready, a dedicated clinical intake and client portal architecture can follow as a planned next phase." },
];

export const BRAND_DELIVERABLES = [
  "Business naming",
  "Brand positioning",
  "Messaging architecture",
  "Logo and visual identity",
  "Colour and typography system",
  "Website copywriting",
  "Image direction and sourcing",
  "Brand guidelines",
  "Launch-ready core marketing assets",
];

export const PALETTE = [
  { name: "Warm cream", hex: "#F6F0E6" },
  { name: "Pale sage", hex: "#E6E8DE" },
  { name: "Sage", hex: "#6F806E" },
  { name: "Clay", hex: "#B66E50" },
  { name: "Deep green", hex: "#26342E" },
  { name: "Muted gold", hex: "#C29A4A" },
];

/* ------------------------------------------------------------------
 * FORM CONFIGURATION POINT
 * Meeting requests are stored in the app's own database via the
 * endpoint below. To also notify a person or push to a CRM, set
 * notifyEmail / crmEndpoint here and ask for the backend hook to be
 * enabled (Resend playbook). Until then, requests are only stored.
 * ------------------------------------------------------------------ */
export const FORM_CONFIG = {
  endpoint: "/api/meeting-requests",
  notifyEmail: "", // e.g. "proposals@blankspacemedia.co.za", not yet connected
  crmEndpoint: "",
};

/* Single configuration point for the downloadable formal proposal. */
export const PROPOSAL_PDF_URL = "/Blank_Space_Media_Formal_Proposal.pdf";

export const ASSUMPTIONS = [
  "Final page quantities are confirmed together during discovery and content planning.",
  "An agreed number of practitioner profiles is included; additional profiles can be added at any stage.",
  "An agreed number of initial articles and resources is loaded before launch; the library is designed to grow with you.",
  "Two structured revision rounds are included at each design stage, so decisions stay calm and unhurried.",
  "Client approvals and content are assumed within five working days per stage, keeping the 8–12 week window comfortable.",
  "Third-party platform fees, hosting plans and software licences are billed separately unless specifically added.",
  "Specialist photography commissions are quoted separately; the direction and sourcing of imagery is included.",
  "Paid-media campaigns are excluded, though the platform is built ready for them.",
  "External legal or clinical review, where required, is arranged by the practice.",
  "Additional integrations beyond the agreed scope are quoted before any work begins, never after.",
  "Any change in scope follows a simple written variation we agree together before it affects the timeline or investment.",
  "Final ownership, operating and handover arrangements are confirmed plainly in the final agreement.",
];

export const EXECUTIVE_OVERVIEW = [
  { title: "Our understanding", text: "A new mental-health venture needs more than pages. It needs a brand people trust and a digital front door that turns quiet uncertainty into confident enquiry, for individuals, families, schools and future practitioners alike." },
  { title: "The proposed solution", text: "A complete brand and digital experience: naming and identity, a calm editorial website, guided pathways for every audience, three private enquiry routes, and a resource library that builds authority over time." },
  { title: "Included scope", text: "Brand foundation, core website, the care experience, and organisational and learning pathways, delivered as one coherent first release by Blank Space Media, supported behind the scenes by StrateNova." },
  { title: "Delivery period", text: "An 8–12 week window across six phases, with clear decision gates and two contingency weeks protecting the launch date." },
  { title: "Recommended investment", text: "R84 500 excluding VAT, structured across four calm milestones, from appointment to launch. Upfront (R80 275) and extended (R90 000) structures are also available." },
  { title: "Ongoing care", text: "R4 500 per month excluding VAT: hosting coordination, security and form checks, routine changes, a monthly article or event, and an analytics review." },
];
